import React from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import OTableHeadComleted from 'components/reusable/OTableHead';
import helpers from 'utils/helpers';
import { Rating } from '@mui/material';
import { AiFillEye } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
const IncomingTable = ({ filteredData, sort, setSort, page }) => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  return (
    <div className="overflow-x-auto relative rounded-lg border">
      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
        <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400 dark:border-[#ffffff38]">
          
          <tr>
            <th scope="col" className="py-3 px-3 text-center">
              {t("S.NO")}
            </th>
            <OTableHeadComleted
              sort={sort}
              name={"Completion Date & Time"}
              fieldName={"completedAt"}
              setSort={setSort}
            />
            <OTableHeadComleted
              sort={sort}
              name={"Service Type"}
              setSort={setSort}
            />

            <OTableHeadComleted
              sort={sort}
              name={"Customer"}
              setSort={setSort}
            />
            <OTableHeadComleted
              sort={sort}
              tableClass='text-right'
              name={"Booking ID"}
              setSort={setSort}
            />
            <OTableHeadComleted
              sort={sort}
              name={t("Assigned Driver")}
              setSort={setSort}
            />
            <OTableHeadComleted
              sort={sort}
              name={"Rating"}
              tableClass='text-center'
              setSort={setSort}
            />
            <OTableHeadComleted
              sort={sort}
              name={"Booking Type"}
              fieldName={"bookingType"}
              setSort={setSort}
            />
            <OTableHeadComleted
              sort={sort}
              name={"Earnings"}
              classTd='justify-end'
              fieldName={"totalAmount"}
              setSort={setSort}
            />
            <OTableHeadComleted
              sort={sort}
              name={"Tip Received"}
              classTd='justify-end'
              fieldName={"tip"}
              setSort={setSort}
            />

            <OTableHeadComleted
              sort={sort}
              name={"Payout Status"}
              classTd='text-center'
              setSort={setSort}
            />

            <OTableHeadComleted sort={sort} name={"ACTION"} />
          </tr>
        </thead>
        <tbody>
          <AnimatePresence>
            {filteredData?.map((item, idx) => (
              <motion.tr
                key={item?._id}
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.05 }}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <td className="py-3 text-center px-4 border-r font-medium text-gray-900  dark:text-white">
                  {" "}
                  {idx + 1 + 10 * (page - 1)}
                </td>
                <td className="py-3 px-4 border-r">
                  {helpers.getDateAndTime(
                    item?.completedAt,
                    "MM-DD-YYYY HH:MM A"
                  )}
                </td>
                <td className="py-3 px-4 border-r">
                  {helpers.capitalizeFirstWord(item?.serviceDetails?.name)}
                </td>

                <td className="py-3 px-4 border-r">
                  {helpers.capitalizeFirstWord(item?.userDetails?.fullName)}
                </td>
                <td className="py-3 px-4 border-r text-right">#{item?.bookingId}</td>
                <td className="py-3 px-4 border-r">
                  {helpers.capitalizeFirstWord(item?.driverDetails?.fullName)}
                </td>

                <td className="py-3 px-4 border-r text-center">
                  <Rating
                    name="read-only"
                    value={item?.rating}
                    precision={0.5}
                    readOnly
                  />
                </td>
                <td className="py-3 px-4 border-r font-semibold">
                  {helpers.capitalizeFirstWord(item?.bookingType)}
                </td>
                <td className="py-3 px-4 border-r font-semibold text-right">
                  {helpers.formattedAmount(item?.spEarning || 0)}
                </td>
                <td className="py-3 px-4 border-r font-semibold text-right">
                  {helpers.formattedAmount(item?.tip || 0)}
                </td>

                <td className={`py-3 px-4 border-r font-semibold text-center ${helpers.getTextColor(item?.payoutStatus)}`}>
                  {helpers.capitalizeFirstWord(item?.payoutStatus)}
                </td>

                <td
                  onClick={() => {
                    navigate(`/track-services/view/${item?._id}`);
                  }}
                  className="px-2 py-2 border-l text-center hover:bg-white hover:text-LightBlue dark:hover:bg-transparent "
                  title={"View"}
                >
                  <span className="flex justify-center items-center h-full">
                    <AiFillEye
                      className="text-slate-600 cursor-pointer"
                      size={23}
                    />
                  </span>
                </td>
              </motion.tr>
            ))}
          </AnimatePresence>

          {isEmpty(filteredData) ? (
            <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
              <td className="py-4 px-6" colSpan={12}>
                {t("O_NO_RECORD_FOUND")}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}

export default IncomingTable